import Vue from "vue";

export const AnalyticsEventBus = new Vue();

class Analytics {
  emitEvent(eventName: string, data: any) {
    AnalyticsEventBus.$emit(eventName, data);
  }
}

export const analytics = new Analytics();

export const event = Object.freeze({
  in_app: Object.freeze({
    onlineview_edit_tour_document: "Online View Edit Tour Document In Application",
    onlineview_close_edit_tour_document: "Close Online View Edit Tour Document In Application",
    onlineview_go_to_logo_setting_tour_document: "Online View Go To Logo Setting Tour Document In Application",
    onlineview_close_logo_setting_tour_document: "Close Online View Logo Setting Tour Document In Application",
    onlineview_go_to_signature_setting: "Online View Go To Signature Setting Tour Document In Application",
    onlineview_close_signature_setting_tour_document:
      "Close Online View Signature Setting Tour Document In Application",
  }),
});
